import type { CreateEnrollmentRequest, EnrollmentCreated } from "./types";

export type EnrollmentDraft = {
  displayName: string;
  assetId: string;
  site: string;
  ownerTeam: string;
  tags: string;
  notes: string;
};

function optional(value: string): string | undefined {
  return value.trim() || undefined;
}

export function enrollmentRequest(draft: EnrollmentDraft): CreateEnrollmentRequest {
  const tags = [...new Set(draft.tags.split(",").map((tag) => tag.trim()).filter(Boolean))];
  return {
    display_name: draft.displayName.trim(),
    asset_id: optional(draft.assetId),
    site: optional(draft.site),
    owner_team: optional(draft.ownerTeam),
    tags: tags.length ? tags : undefined,
    notes: optional(draft.notes),
  };
}

export function bootstrapHandoff(enrollment: EnrollmentCreated): string {
  return JSON.stringify(
    {
      enrollment_id: enrollment.enrollment_id,
      device_id: enrollment.device_id,
      activation_token: enrollment.activation_token,
      expires_at: enrollment.expires_at,
    },
    null,
    2,
  );
}
